// edit-item-modal.component.ts
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {AddNewUserService} from '../services/add-new-user.service';

@Component({
  selector: 'confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  @Input() row: any;
  @Input() message: any;
  isSaving: boolean = false;
  constructor(private addNewUserService: AddNewUserService, public activeModal: NgbActiveModal) {}

  save() {
    this.isSaving = true;
    // Logic to save data
    console.log('Saving data', this.row);
    this.addNewUserService.removeUser(this.row).subscribe(
      (response) => {
        this.isSaving = false;
        console.log(response);
        this.activeModal.close('saved'); 
      },
    (error) => {
      console.log(error);
    })
  }

  close() {
    this.activeModal.close('closed'); 
  }

}
